import React, { useState } from "react";
import { Form } from "react-bootstrap";
import AbsoluteSL from "./AbsoluteSL";
import FixedTSL from "./FixedTSL";
import VariableTSL from "./VariableTSL";
import { BotType, StoplossType, StoplossTypeName } from "../../../../Const";
import { connect, useSelector, useDispatch } from "react-redux";
import { CHANGE_SL_TYPE } from "../../../../actions/create-bot-type";
import "./StopLossView.scss";
import TutorialPopup from "../../../help/TutorialPopup";
import { slFixed, slVariable } from "../../../../utils/HelpContent";
import LeftRightForm from "../modules/LeftRightForm";

const StopLossView = (props) => {
  const {t} = props;
  const newBot = useSelector((state) => state.createBot.newBot) || {};
  const isPremiumBot = (newBot.botType === BotType.advance || newBot.botType === BotType.exit)
  const slType = newBot.stoplossType;
  const dispatch = useDispatch();
  const changeSLType = (val) => {
    dispatch({
      type: CHANGE_SL_TYPE,
      payload: val,
    });
  };

  const options = Object.keys(StoplossType).map((item, id) => (
    <option key={id} value={StoplossType[item]}>
      {StoplossTypeName[item]}
    </option>
  ));
  let slView;
  switch (slType) {
    case StoplossType.absolute:
      slView = <AbsoluteSL min={0} max={100} value={newBot.stoploss} hideLabel={true} isPremiumBot={isPremiumBot} t={t}/>;
      break;
    case StoplossType.fixedTsl:
      slView = <FixedTSL newBot={newBot} />;
      break;
    case StoplossType.variableTsl:
      slView = <VariableTSL newBot={newBot} />;
      break;
  }
  return (
    <>
    
    <div className="stoploss-view">
    {isPremiumBot && 
      <LeftRightForm 
        left={<>
         <h6>
          Stoploss {isPremiumBot && "Type:"}
          {slType !== StoplossType.absolute && (
          <TutorialPopup
            content={slType === StoplossType.fixedTsl ? t("slFixed") : t("slVariable")}
          />
        )}
        </h6>
       </>
        }
        right={<div>
          {isPremiumBot && (
            <select value={slType} onChange={(e) => changeSLType(e.target.value)} className="form-control select-normal">
              {options}
            </select>
          )}
          
          </div>}
      ></LeftRightForm> }
      {slView}
    </div>
    </>
    

    
  );
};

export default connect(null)(StopLossView);
